module.exports = __webpack_public_path__ + "img/loading.1da2a4e1.png";